"use strict";

var dataHooks = {
  title: 'MessageModal-title',
  titleText: 'MessageModal-title-text',
  content: 'MessageModal-content',
  contentText: 'MessageModal-contentText',
  illustration: 'MessageModal-illustration',
  illustrationSrc: 'MessageModal-illustrationSrc'
};
module.exports = {
  dataHooks: dataHooks
};